import { Snackbar, Alert } from "@mui/material";
import styles from "./Snackbar.module.scss";

const ErrorSnackbar = ({ open, message, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity="error"
        variant="filled"
        className={`${styles.alert} ${styles.errorAlert}`}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ErrorSnackbar;
